import { now } from '../timing';
let ric = globalThis.requestIdleCallback;
if (!ric) {
    const remainTime = 7.0;
    ric = function requestIdleCallbackPolyfill(callback, options) {
        const startTime = now();
        return setTimeout(() => {
            const elapsedTime = now() - startTime;
            callback({
                didTimeout: (options?.timeout != null && elapsedTime > options.timeout) ?? false,
                timeRemaining() {
                    return Math.max(0, remainTime - elapsedTime);
                },
            });
        });
    };
}
let cic = globalThis.cancelIdleCallback;
if (!cic) {
    cic = function cancelIdleCallbackPolyfill(handle) {
        clearTimeout(handle);
    };
}
export { cic as cancelIdleCallback, ric as requestIdleCallback };
